import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import PDFMetadataEditorImageListScreen from "./PDFMetadataEditorImageListScreen";
import { BASE_URL } from "../Config";

function PDFMetadataEditorMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "PDF Metadata Editor" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_metadata_editor", title: "Edit PDF Metadata" },
    data2: { link: "/pdf_metadata_editor", title: "PDF Editor Online" },
    data3: { link: "/pdf_metadata_editor", title: "PDF Properties Editor" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Edit PDF metadata online easily. Change title, author, keywords, and properties quickly with our fast and secure PDF metadata editor."
      ></meta>
      <meta
        name="keywords"
        content="pdf metadata editor, edit pdf metadata, pdf properties editor, change pdf metadata, pdf title editor, pdf author editor, edit pdf properties, online pdf metadata editor, pdf keyword editor, pdf info editor, metadata pdf tool, pdf document properties, pdf metadata changer, pdf editor online, pdf management tool"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <PDFMetadataEditorImageListScreen
          title={title}
        ></PDFMetadataEditorImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF Metadata Editor website provides a secure, powerful, and easy-to-use solution to edit and manage PDF metadata both offline and online. Built for professionals, students, and businesses, this advanced tool allows users to edit PDF title, author, subject, keywords, producer, and other document properties with precision and speed. With offline functionality, all metadata editing is performed directly on your device, ensuring complete privacy and data protection without uploading files to external servers. When internet access is available, users can also edit PDF online using a smooth, browser-based interface for quick updates and real-time document optimization. Properly edited PDF metadata improves document organization, accessibility, and search engine indexing, helping files rank better in search results. As a versatile PDF editor online, the platform supports essential document workflows and integrates seamlessly with other PDF tools such as compression, resizing, and format optimization. Using advanced processing technology, the editor preserves original formatting and content quality while updating metadata instantly. Compatible with desktop and mobile devices, this PDF metadata editor helps improve SEO for PDF files, enhance document discoverability, and maintain professional standards. If you are looking for the best PDF metadata editor online, offline PDF metadata editor, PDF editor online, or a secure way to edit PDF online, this website delivers a complete, reliable, and privacy-focused PDF editing experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Edit",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Metadata Editor"
            why_use={[
              {
                title: "Improve PDF Search Visibility (SEO)",
                description:
                  "Our PDF metadata editor allows you to edit PDF title, author, subject, and keywords, helping search engines index your documents correctly and improving rankings in search results.",
              },
              {
                title: "Better Document Organization",
                description:
                  "Editing PDF metadata helps organize large collections of files. With a PDF metadata editor online, you can manage document properties efficiently and find files faster.",
              },
              {
                title: "Edit PDF Online with Ease",
                description:
                  "Using an edit PDF online tool, users can quickly update metadata without installing heavy software, saving time and effort.",
              },

              {
                title: "Enhance Professional Appearance",
                description:
                  "Accurate metadata makes PDFs look more professional. A reliable PDF editor online ensures your documents display correct author names, titles, and descriptions.",
              },
              {
                title: "Protect Privacy and Sensitive Information",
                description:
                  "PDF files often contain hidden metadata. A PDF metadata editor offline helps remove or update sensitive details to maintain privacy and data security.",
              },
              {
                title: "Improve Accessibility and Compatibility",
                description:
                  "Well-structured metadata improves accessibility for screen readers and ensures better compatibility across devices and platforms using a trusted PDF metadata editor.",
              },
              {
                title: "Optimize PDFs for Sharing and Publishing",
                description:
                  "When sharing or publishing documents online, optimized metadata increases discoverability. A PDF metadata editor online helps your PDFs perform better on websites and content platforms.",
              },
              {
                title: "Support SEO-Friendly PDF Content",
                description:
                  "Search engines rely on metadata to understand PDF content. Using a PDF metadata editor ensures your PDFs are optimized with relevant keywords for better SEO performance.",
              },
              {
                title: "Work Offline and Online Anytime",
                description:
                  "This offline and online PDF metadata editor gives flexibility to edit documents securely without internet access or quickly edit PDF online when connected.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default PDFMetadataEditorMain;
